import { render, staticRenderFns } from "./EstruturaCadastro.vue?vue&type=template&id=092f721c&lang=html&"
import script from "./EstruturaCadastro.vue?vue&type=script&lang=js&"
export * from "./EstruturaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaCadastro.vue
// module id = 1386
// module chunks = 28